import * as angular from "angular";
import { PermissionCheck } from "../../shared/permission";
import { UserDataProvider } from "../../data-provider/user.dp";
import { LimitDataProvider } from "../../data-provider/limit.dp";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { Limit } from "../../models/limit.model";

let UserStatsComponent = {
    selector: "vcUserStats",
    templateUrl: "/angular/components/user/user-stats.component.html",
    bindings: {},
    controller: class UserStatsController {
        // * bindings for typescript compiler *
        public activeTab?: any;
        public create?: any;
        public showing?: any;
        public provider?: any;
        public itemType?: any;
        public items?: any;
        public function?: any;
        // ************************************

        private __env: any;
        public dataProvider: UserDataProvider;

        public limits: object;
        public isOrgCampaign: boolean;
        public permissionProvider: PermissionCheck;
        public isLeaderView: boolean;

        constructor(
            __env: any,
            __app_type: string,
            PermissionCheck: PermissionCheck,
            UserDataProvider: UserDataProvider,
            LimitDataProvider: LimitDataProvider,
            CampaignDataProvider: CampaignDataProvider
        ) {
            this.__env = __env;
            this.permissionProvider = PermissionCheck;
            this.dataProvider = UserDataProvider;
            this.dataProvider.getUsersCount();
            this.isOrgCampaign =
                CampaignDataProvider.getActiveCampaign().isOrganisationCampaign();

            this.isLeaderView = __app_type == "LEADER";
            LimitDataProvider.get().then((limits: Limit) => {
                this.limits = limits;
            });
        }
    },
};

angular
    .module("user")
    .component(UserStatsComponent.selector, UserStatsComponent);
